<template>
  <graph-detail08-template
    :board-ids="[244]"
    field-code="facility"
    :com-group-list="comGroupList"
    graph1-title="전체 (시설물) 중대재해 발생 현황"
    graph2-title="월별 (시설물) 중대재해 발생 현황"
    graph3-title="기간별 (시설물) 중대재해 발생 현황"
    field-label="시설물"
    field-category-label="시설물 구분"
  />
</template>

<script>
/* eslint-disable brace-style */
import GraphDetail08Template from "@/views/graph-detail/GraphDetail08Template.vue";

export default {
  name: "GraphDetail65",
  components: {
    GraphDetail08Template,
  },
  props: {
    comGroupList: Object,
  },
};
</script>

<style scoped></style>
